module.exports = __webpack_public_path__ + "img/Richie.2f564a76.jpg";